import { Component, Input, OnInit } from "@angular/core";
import { FromToDetail, ReportSignature } from "../../../../../_objects/report-element";
import { Notifier, OfflineReportPreviewService, MousePoint } from "../../../../../_services/offline-report-preview.service";

@Component({
  selector: "app-report-signature",
  templateUrl: "./report-signature.component.html",
  styleUrls: ["./report-signature.component.scss"],
  standalone: false
})
export class ReportSignatureOfflineComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public signatureKey: string;
  @Input() public elementLocation: string;
  public reportSignature: ReportSignature;
  private notifier: Notifier;
  private resizeMarkerSize: number;
  private resizing: boolean;

  readonly signatureStyle = "overflow: hidden; position: absolute;";

  constructor(public designService: OfflineReportPreviewService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: "report-signature.component",
      ids: { pageId: this.pageKey, elementId: this.signatureKey }
    };
    this.reportSignature = this.designService.getSignature(this.signatureKey);
  }

  public onClick(event: MouseEvent) {}

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + "px";
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case "left":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "center":
        return this.reportSignature.getWidthPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "right":
        return this.reportSignature.getWidthPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    switch (vertical) {
      case "top":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "middle":
        return this.reportSignature.getHeightPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "bottom":
        return this.reportSignature.getHeightPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public onDragStart(event: DragEvent) {
    event.dataTransfer.setData("text", this.signatureKey);
    event.dataTransfer.effectAllowed = "move";

    const fromDetail: FromToDetail = {
      location: this.reportSignature.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
  }

  public onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    event.stopPropagation();
  }

  public onDrop(event: DragEvent) {
    event.preventDefault();
    const template = { ...this.designService.originTemplate };
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    const dragElemId = event.dataTransfer.getData("text");

    const toDetail: FromToDetail = {
      location: this.reportSignature.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportSignature.getLeftPx() + event.offsetX,
      onElementY: this.reportSignature.getTopPx() + event.offsetY
    };

    event.dataTransfer.clearData("text");
    event.stopPropagation();
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
    event.stopPropagation();
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }
}
